import { types } from '../constants/ActionTypes'
import AsyncContainer from '../containers/Common/AsyncContainer'
import html2canvas from 'html2canvas'

export const window = {
  resize: (width, height) => ({
    type: types.window.RESIZE,
    width,
    height,
  })
}

export const signUpCard = {
  enabled: () => ({
    type: types.signUpCard.ENABLED,
  }),
  disabled: () => ({
    type: types.signUpCard.DISABLED,
  }),
  changedText: (name, text) => ({
    type: types.signUpCard.CHANGED_TEXT,
    name,
    text,
  }),
}

export const user = {
  unmount: () => ({
    type: types.user.UNMOUNT,
  }),
  receiveUserProfile: (userProfile) => ({
    type: types.user.RECEIVE_USER_PROFILE,
    userProfile
  }),
  changedTab: (tabId) => ({
    type: types.user.CHANGED_TAB,
    tabId,
  })
}

export const userMenu = {
  open: (anchorEl) => ({
    type: types.userMenu.OPEN,
    anchorEl,
  }),
  close: () => ({
    type: types.userMenu.CLOSE,
  })
}

export const settings = {
  responseUploadAvatar: (response) => ({
    type: types.settings.RESPONSE_UPLOAD_AVATAR,
    response,
  }),
  responseUploadHeader: (response) => ({
    type: types.settings.RESPONSE_UPLOAD_HEADER,
    response,
  }),
  responseUpdate: (response, targets) => ({
    type: types.settings.RESPONSE_UPDATE,
    response,
    targets,
  }),
}

export const accountSettingsCard = {
  init: (settings) => ({
    type: types.accountSettingsCard.INIT,
    settings,
  }),
  unmount: () => ({
    type: types.accountSettingsCard.UNMOUNT,
  }),
  changedPhoto: (name, data) => ({
    type: types.accountSettingsCard.CHANGED_PHOTO,
    name,
    data,
  }),
  changedText: (name, text) => ({
    type: types.accountSettingsCard.CHANGED_TEXT,
    name,
    text,
  }),
  responseUploadAvatar: (response) => ({
    type: types.accountSettingsCard.RESPONSE_UPLOAD_AVATAR,
    response,
  }),
  responseUploadHeader: (response) => ({
    type: types.accountSettingsCard.RESPONSE_UPLOAD_HEADER,
    response,
  }),
  responseUpdateDisplayName: (response) => ({
    type: types.accountSettingsCard.RESPONSE_UPDATE_DISPLAYNAME,
    response,
  }),
  responseUpdate: (response, targets) => ({
    type: types.accountSettingsCard.RESPONSE_UPDATE,
    response,
    targets,
  }),
  startSave: () => ({
    type: types.accountSettingsCard.START_SAVE,
  }),
  endSave: () => ({
    type: types.accountSettingsCard.END_SAVE,
  }),
}

export const boardSettingsCard = {
  changedSwitch: (name) => ({
    type: types.boardSettingsCard.CHANGED_SWITCH,
    name
  })
}

export const leftMenuBar = {
  open: () => ({
    type: types.leftMenuBar.OPEN,
  }),
  close: () => ({
    type: types.leftMenuBar.CLOSE,
  })
}

export const titleGrid = {
  menu: {
    open: (anchorEl) => ({
      type: types.titleGrid.menu.OPEN,
      anchorEl,
    }),
    close: () => ({
      type: types.titleGrid.menu.CLOSE,
    })
  }
}

export const webBoard = {
  init: (boardType, urlParams, liveId) => ({
    type: types.webBoard.INIT,
    boardType,
    urlParams,
    liveId,
  }),
  refresh: (changeMode = true) => ({
    type: types.webBoard.REFRESH,
    changeMode
  }),
  fileTitleCard: {
    changedMode: (mode) => ({
      type: types.webBoard.fileTitleCard.CHANGED_MODE,
      mode,
    }),
  },
  confirmDialog: {
    open: (name) => ({
      type: types.webBoard.confirmDialog.OPEN,
      name,
    }),
    close: (name) => ({
      type: types.webBoard.confirmDialog.CLOSE,
      name,
    }),
    changedText: (name, text) => ({
      type: types.webBoard.confirmDialog.CHANGED_TEXT,
      name,
      text,
    })
  },
}

export const storeBoardCard = {
  unmount: () => ({
    type: types.storeBoardCard.UNMOUNT,
  }),
  recordMenu: {
    edit: (id, boardContext) => ({
      type: types.storeBoardCard.recordMenu.EDIT,
      id,
      boardContext,
    })
  }
}

export const renjuBoardCard = {
  resizeBoard: (bid) => ({
    type: types.renjuBoardCard.RESIZE_BOARD,
    bid,
  }),
  close: (bid) => ({
    type: types.renjuBoardCard.CLOSE,
    bid,
  }),
  analyzeModeOn: (bid) => ({
    type: types.renjuBoardCard.ANALYZE_MODE_ON,
    bid,
  }),
  analyzeModeOff: (bid) => ({
    type: types.renjuBoardCard.ANALYZE_MODE_OFF,
    bid,
  }),
  markModeOn: (bid) => ({
    type: types.renjuBoardCard.MARK_MODE_ON,
    bid,
  }),
  markModeOff: (bid) => ({
    type: types.renjuBoardCard.MARK_MODE_OFF,
    bid,
  }),
  changedInsertStrings: (bid, insertStrings) => ({
    type: types.renjuBoardCard.CHANGED_INSERT_STRINGS,
    bid,
    insertStrings,
  }),
  removeMark: (bid) => ({
    type: types.renjuBoardCard.REMOVE_MARK,
    bid,
  }),
  selectedEditMode: (bid, selectedIndex) => ({
    type: types.renjuBoardCard.SELECTED_EDIT_MODE,
    bid,
    selectedIndex,
  }),
  selectedOperationMode: (bid, selectedIndex) => ({
    type: types.renjuBoardCard.SELECTED_OPERATION_MODE,
    bid,
    selectedIndex,
  }),
  changedStoneType: (bid, stoneType) => ({
    type: types.renjuBoardCard.CHANGED_STONE_TYPE,
    bid,
    stoneType,
  }),
  selectedTurnMenu: (bid, selectedIndex) => ({
    type: types.renjuBoardCard.SELECTED_TURN_MENU,
    bid,
    selectedIndex,
  }),
  clickRenjuBoard: (bid, event) => ({
    type: types.renjuBoardCard.CLICK_RENJU_BOARD,
    bid,
    event,
  }),
  rightClickRenjuBoard: (bid, event) => ({
    type: types.renjuBoardCard.RIGHT_CLICK_RENJU_BOARD,
    bid,
    event,
  }),
  specifiedWidthOn: (bid) => ({
    type: types.renjuBoardCard.SPECIFIED_WIDTH_ON,
    bid,
  }),
  specifiedWidthOff: (bid) => ({
    type: types.renjuBoardCard.SPECIFIED_WIDTH_OFF,
    bid,
  }),
  changedSettings: (bid, settings) => ({
    type: types.renjuBoardCard.CHANGED_SETTINGS,
    bid,
    settings,
  }),
  changedGameInfo: (bid, gameInfo) => ({
    type: types.renjuBoardCard.CHANGED_GAME_INFO,
    bid,
    gameInfo,
  }),
  changedPuzzleInfo: (bid, puzzleInfo) => ({
    type: types.renjuBoardCard.CHANGED_PUZZLE_INFO,
    bid,
    puzzleInfo,
  }),
  openAnalyzeTab: (bid) => ({
    type: types.renjuBoardCard.OPEN_ANALYZE_TAB,
    bid,
  }),
  changedSwap: (bid, swap) => ({
    type: types.renjuBoardCard.CHANGED_SWAP,
    bid,
    swap,
  }),
  decision: (bid, decisionType) => ({
    type: types.renjuBoardCard.DECISION,
    bid,
    decisionType,
  }),
  changedFiveMoveNumber: (bid, value) => ({
    type: types.renjuBoardCard.CHANGED_FIVE_MOVE_NUMBER,
    bid,
    value,
  }),
  openMessage: (bid) => ({
    type: types.renjuBoardCard.OPEN_MESSAGE,
    bid,
  }),
  closeMessage: (bid) => ({
    type: types.renjuBoardCard.CLOSE_MESSAGE,
    bid,
  }),
 }

export const operationModeMenu = {
  open: (bid, anchorEl) => ({
    type: types.operationModeMenu.OPEN,
    bid,
    anchorEl,
  }),
  close: (bid) => ({
    type: types.operationModeMenu.CLOSE,
    bid,
  }),
}

export const turnSelectMenu = {
  open: (bid, anchorEl) => ({
    type: types.turnSelectMenu.OPEN,
    bid,
    anchorEl,
  }),
  close: (bid) => ({
    type: types.turnSelectMenu.CLOSE,
    bid,
  }),
}

export const renjuBoardMenu = {
  open: (anchorEl) => ({
    type: types.renjuBoardMenu.OPEN,
    anchorEl,
  }),
  close: () => ({
    type: types.renjuBoardMenu.CLOSE,
  }),
  clickedMenu: (menu) => ({
    type: types.renjuBoardMenu.CLICKED_MENU,
    menu
  }),
}

export const settingsDialog = {
  open: (settings) => ({
    type: types.settingsDialog.OPEN,
    settings,
  }),
  close: () => ({
    type: types.settingsDialog.CLOSE,
  }),
  initialize: (settings) => ({
    type: types.settingsDialog.INITIALIZE,
    settings,
  }),
  changedCheckbox: (name, checked) => ({
    type: types.settingsDialog.CHANGED_CHECKBOX,
    name,
    checked,
  })
}

export const gameInfoDialog = {
  open: () => ({
    type: types.gameInfoDialog.OPEN,
  }),
  close: () => ({
    type: types.gameInfoDialog.CLOSE,
  }),
  initialize: (gameInfo) => ({
    type: types.gameInfoDialog.INITIALIZE,
    gameInfo
  }),
  changedText: (name, text) => ({
    type: types.gameInfoDialog.CHANGED_TEXT,
    name,
    text
  })
}

export const puzzleInfoDialog = {
  open: () => ({
    type: types.puzzleInfoDialog.OPEN,
  }),
  close: () => ({
    type: types.puzzleInfoDialog.CLOSE,
  }),
  initialize: (puzzleInfo) => ({
    type: types.puzzleInfoDialog.INITIALIZE,
    puzzleInfo,
  }),
  changedText: (name, text) => ({
    type: types.puzzleInfoDialog.CHANGED_TEXT,
    name,
    text,
  })
}

export const controlButtons = {
  startPlay: (bid) => (dispatch, getState) => {
    var intervalId = setInterval(() => dispatch(controlButtons.fastForward(bid)), 1000)
    dispatch({
      type: types.controlButtons.START_PLAY,
      bid: bid,
      intervalId,
    })
  },
  stopPlay: (bid) => ({
    type: types.controlButtons.STOP_PLAY,
    bid: bid,
  }),
  skipPrevious: (bid) => ({
    type: types.controlButtons.SKIP_PREVIOUS,
    bid: bid,
  }),
  fastRewind: (bid) => ({
    type: types.controlButtons.FAST_REWIND,
    bid: bid,
  }),
  fastForward: (bid) => ({
    type: types.controlButtons.FAST_FORWARD,
    bid: bid,
  }),
  skipNext: (bid) => ({
    type: types.controlButtons.SKIP_NEXT,
    bid: bid,
  }),
}

export const downloadImageDialog = {
  open: () => ({
    type: types.downloadImageDialog.OPEN,
  }),
  close: () => ({
    type: types.downloadImageDialog.CLOSE,
  }),
}

export const shareDialog = {
  open: () => ({
    type: types.shareDialog.OPEN,
  }),
  close: () => ({
    type: types.shareDialog.CLOSE,
  }),
  makedURL: (url) => ({
    type: types.shareDialog.MAKED_URL,
    url,
  }),
}

export const tweetDialog = {
  open: () => ({
    type: types.tweetDialog.OPEN,
  }),
  close: () => ({
    type: types.tweetDialog.CLOSE,
  }),
  makedURL: (url) => ({
    type: types.tweetDialog.MAKED_URL,
    url,
  }),
  defaultText: (text) => ({
    type: types.tweetDialog.DEFAULT_TEXT,
    text
  }),
  changedHashTags: (tags) => ({
    type: types.tweetDialog.CHANGED_HASHTAGS,
    tags
  }),
  changedLevel: (level) => ({
    type: types.tweetDialog.CHANGED_LEVEL,
    level,
  }),
  changedText: (name, text, twitterText) => ({
    type: types.tweetDialog.CHANGED_TEXT,
    name,
    text,
    twitterText,
  }),
  changedCheckbox: (name, checked) => ({
    type: types.tweetDialog.CHANGED_CHECKBOX,
    name,
    checked,
  }),
  tweet: () => ({
    type: types.tweetDialog.TWEET,
  })
}

export const tweetListDialog = {
  open: () => ({
    type: types.tweetListDialog.OPEN,
  }),
  close: () => ({
    type: types.tweetListDialog.CLOSE,
  }),
  changedPage: (page) => ({
    type: types.tweetListDialog.CHANGED_PAGE,
    page
  }),
  changedRowsPerPage: (rowsPerPage) => ({
    type: types.tweetListDialog.CHANGED_ROWS_PER_PAGE,
    rowsPerPage,
  }),
  openConfirmDialog: (deleteId) => ({
    type: types.tweetListDialog.OPEN_CONFIRM_DIALOG,
    deleteId,
  }),
  closeConfirmDialog: () => ({
    type: types.tweetListDialog.CLOSE_CONFIRM_DIALOG,
  })
}

// comment
export const comment = {
  responseAdd: (response) => ({
    type: types.comment.RESPONSE_ADD,
    response,
  }),
  responseDelete: (response) => ({
    type: types.comment.RESPONSE_DELETE,
    response,
  }),
  requestSelect: () => ({
    type: types.comment.REQUEST_SELECT,
  }),
  responseSelect: (response) => ({
    type: types.comment.RESPONSE_SELECT,
    response,
  }),
}

// event
export const eventCard = {
  mount: () => ({
    type: types.eventCard.MOUNT,
  }),
  unmount: () => ({
    type: types.eventCard.UNMOUNT,
  }),
  requestSelect: () => ({
    type: types.eventCard.REQUEST_SELECT,
  }),
  responseSelect: (response) => ({
    type: types.eventCard.RESPONSE_SELECT,
    response,
  })
}
export const eventListCard = {
  requestSelectEvent: () => ({
    type: types.eventListCard.REQUEST_SELECT_EVENT,
  }),
  responseSelectEvent: (response) => ({
    type: types.eventListCard.RESPONSE_SELECT_EVENT,
    response,
  }),
}

export const eventRegister = {
  changedText: (name, text) => ({
    type: types.eventRegister.CHANGED_TEXT,
    name,
    text,
  }),
  changedDateTime: (name, value) => ({
    type: types.eventRegister.CHANGED_DATETIME,
    name,
    value,
  }),
  changedGeoCode: (geoCode) => ({
    type: types.eventRegister.CHANGED_GEO_CODE,
    geoCode,
  }),
  changedLatLng: (latLng) => ({
    type: types.eventRegister.CHANGED_LATLNG,
    latLng,
  }),
  changedPhoto: (name, data) => ({
    type: types.eventRegister.CHANGED_PHOTO,
    name,
    data,
  }),
  changedCheckbox: (name, check) => ({
    type: types.eventRegister.CHANGED_CHECKBOX,
    name,
    check,
  }),
  deleteAddress: () => ({
    type: types.eventRegister.DELETE_ADDRESS,
  }),
  register: (data) => ({
    type: types.eventRegister.REGISTER,
    data,
  }),
  responseAddEvent: (response) => ({
    type: types.eventRegister.RESPONSE_ADD_EVENT,
    response,
  }),
  responseSelectEvent: (response) => ({
    type: types.eventRegister.RESPONSE_SELECT_EVENT,
    response,
  }),
}

// liveList
export const liveList = {
  clearBoardContext: () => ({
    type: types.liveList.CLEAR_BOARD_CONTEXT,
  }),
  clearPageNavigation: () => ({
    type: types.liveList.CLEAR_PAGE_NAVIGATION,
  }),
  changeViewMode: (mode) => ({
    type: types.liveList.CHANGE_VIEW_MODE,
    mode,
  }),
  nextPage: () => ({
    type: types.liveList.NEXT_PAGE,
  }),
  backPage: () => ({
    type: types.liveList.BACK_PAGE,
  })
}

// LivePage
export const liveSettings = {
  init: () => ({
    type: types.liveSettings.INIT,
  }),
  changedText: (name, text) => ({
    type: types.liveSettings.CHANGED_TEXT,
    name,
    text,
  })
}

// LiveGame
export const liveGame = {
  openConfirmDialog: () => ({
    type: types.liveGame.OPEN_CONFIRM_DIALOG,
  }),
  closeConfirmDialog: () => ({
    type: types.liveGame.CLOSE_CONFIRM_DIALOG,
  }),
  changeTab: (tabId, bid, nextBid) => ({
    type: types.liveGame.CHANGE_TAB,
    tabId,
    bid,
    nextBid,
  })
}

export const chatCard = {
  changedText: (name, text) => ({
    type: types.chatCard.CHANGED_TEXT,
    name,
    text,
  }),
  openBoard: (bid, liveId, boardContext, analyzeId) => ({
    type: types.chatCard.OPEN_BOARD,
    bid,
    liveId,
    boardContext,
    analyzeId,
  })
}

export const chatMenu = {
  open: (anchorEl) => ({
    type: types.chatMenu.OPEN,
    anchorEl,
  }),
  close: () => ({
    type: types.chatMenu.CLOSE,
  }),
  selectedMenu: (selectedMenu) => ({
    type: types.chatMenu.SELECTED_MENU,
    selectedMenu,
  }),
  showChatCard: () => ({
    type: types.chatMenu.SHOW_CHAT_CARD,
  }),
  hideChatCard: () => ({
    type: types.chatMenu.HIDE_CHAT_CARD,
  }),
}

export const usereListDialog = {
  open: () => ({
    type: types.userListDialog.OPEN,
  }),
  close: () => ({
    type: types.userListDialog.CLOSE,
  })
}

export const puzzleHome = {
  reset: () => ({
    type: types.puzzleHome.RESET,
  }),
  menu: {
    open: (anchorEl) => ({
      type: types.puzzleHome.menu.OPEN,
      anchorEl
    }),
    close: () => ({
      type: types.puzzleHome.menu.CLOSE,
    }),
  },
  pageNavigation: {
    nextPage: () => ({
      type: types.puzzleHome.pageNavigation.NEXT_PAGE,
    }),
    backPage: () => ({
      type: types.puzzleHome.pageNavigation.BACK_PAGE,
    }),
    clear: () => ({
      type: types.puzzleHome.pageNavigation.CLEAR,
    })
  }
}

export const puzzleRegister = {
  init: () => ({
    type: types.puzzleRegister.INIT
  }),
  next: () => ({
    type: types.puzzleRegister.NEXT,
  }),
  back: () => ({
    type: types.puzzleRegister.BACK,
  }),
  backFirst: () => ({
    type: types.puzzleRegister.BACK_FIRST,
  }),
  selectedStep: (step) => ({
    type: types.puzzleRegister.SELECTED_STEP,
    step,
  }),
  changedText: (name, text) => ({
    type: types.puzzleRegister.CHANGED_TEXT,
    name,
    text
  }),
  changedCheckbox: (name, checked) => ({
    type: types.puzzleRegister.CHANGED_CHECKBOX,
    name,
    checked,
  }),
  addTag: () => ({
    type: types.puzzleRegister.ADD_TAG,
  }),
  removeTag: (index) => ({
    type: types.puzzleRegister.REMOVE_TAG,
    index,
  }),
  responseSelectPuzzle: (response) => ({
    type: types.puzzleRegister.RESPONSE_SELECT_PUZZLE,
    response,
  }),
  confirmDialog: {
    open: () => ({
      type: types.puzzleRegister.confirmDialog.OPEN,
    }),
    close: () => ({
      type: types.puzzleRegister.confirmDialog.CLOSE,
    })
  }
}

export const puzzleViewer = {
  open: (record, isAnswer, isURL = false) => ({
    type: types.puzzleViewer.OPEN,
    record,
    isAnswer,
    isURL,
  }),
  changedText: (name, text) => ({
    type: types.puzzleViewer.CHANGED_TEXT,
    name,
    text,
  }),
  changedCheckbox: (name, checked) => ({
    type: types.puzzleViewer.CHANGED_CHECKBOX,
    name,
    checked,
  }),
  requestSelectPuzzle: () => ({
    type: types.puzzleViewer.REQUEST_SELECT_PUZZLE,
  }),
  responseSelectPuzzle: (response) => ({
    type: types.puzzleViewer.RESPONSE_SELECT_PUZZLE,
    response,
  }),
  comment: {
    openBoard: (index) => ({
      type: types.puzzleViewer.comment.OPEN_BOARD,
      index,
    }),
    closeBoard: (index) => ({
      type: types.puzzleViewer.comment.CLOSE_BOARD,
      index,
    }),
  },
  confirmDialog: {
    open: (confirmType, confirmParams) => ({
      type: types.puzzleViewer.confirmDialog.OPEN,
      confirmType,
      confirmParams,
    }),
    close: () => ({
      type: types.puzzleViewer.confirmDialog.CLOSE,
    }),
  },
}

export const puzzleListCard = {
  unmount: () => ({
    type: types.puzzleListCard.UNMOUNT,
  }),
  changedURLParams: (urlParams) => ({
    type: types.puzzleListCard.CHANGED_URL_PARAMS,
    urlParams,
  }),
  requestSelectPuzzle: () => ({
    type: types.puzzleListCard.REQUEST_SELECT_PUZZLE,
  }),
  responseSelectPuzzle: (response) => ({
    type: types.puzzleListCard.RESPONSE_SELECT_PUZZLE,
    response,
  }),
  menu: {
    open: (anchorEl) => ({
      type: types.puzzleListCard.menu.OPEN,
      anchorEl
    }),
    close: () => ({
      type: types.puzzleListCard.menu.CLOSE,
    }),
  },
}

export const gameRoomListCard = {
  changedGroup: (group) => ({
    type: types.gameRoomListCard.CHANGED_GROUP,
    group,
  }),
}

export const gameRoom = {
  clearChat: (groupName, roomName) => ({
    type: types.gameRoom.CLEAR_CHAT,
    groupName,
    roomName,
  })
}

export const history = {
  responseSelectEventHistory: (response) => ({
    type: types.history.RESPONSE_SELECT_EVENT_HISTORY,
    response,
  })
}

export const snackbar = {
  notify: (message, variant = 'info') => ({
    type: types.snackbar.NOTIFY,
    message,
    variant,
  }),
  close: () => ({
    type: types.snackbar.CLOSE,
  })
}

export const lib = {
  requestCreateBoardImage: (elementId) => (dispatch, getState) => {
    var board = document.getElementById(elementId);
    console.dir(html2canvas)
    html2canvas(board).then((canvas) => {
      console.dir(canvas)
      dispatch(lib.responseCreateBoardImage(canvas.toDataURL()))
    })
  },
  responseCreateBoardImage: (boardImage) => ({
    type: types.lib.RESPONSE_CREATE_BOARD_IMAGE,
    boardImage: boardImage,
  }),
  clearDownloadImage: () => ({
    type: types.lib.CLEAR_DOWNLOAD_IMAGE,
  }),
} 



// WEBPACK FOOTER //
// ./src/actions/index.js